import {
  Document,
} from '../../../../types/models';
import SynchronousDocumentOperation from './synchronous';

export default class SetWritingBuddyOperation extends SynchronousDocumentOperation {
  readonly type = 'set-important-words';

  isEnabled: boolean;

  constructor(documentId: string, isEnabled: boolean) {
    super(documentId);
    this.isEnabled = isEnabled;
  }

  apply(document: Document): Document {
    return {
      ...document,
      meta: {
        ...document.meta,
        hasWritingBuddy: this.isEnabled,
      },
    };
  }
}
